
































































import Vue, { PropType } from 'vue';
import WidgetWrapper from '@/components/widgets/WidgetWrapper.vue';
import FieldInput from '@/components/form/FieldInput.vue';
import { LimitsData } from '@/types/campaign/settings';
import FieldSelect from '@/components/form/FieldSelect.vue';
import { DropdownList, ELimitGoal, ELimitType } from '@/types';
import { getTranslate } from '@/helpers/translateHelpers';

export default Vue.extend({
  name: 'TheLimits',
  components: {
    WidgetWrapper,
    FieldInput,
    FieldSelect,
  },

  props: {
    data: {
      type: Object as PropType<LimitsData>,
      required: true,
    },
  },

  watch: {
    data() {
      this.campaign = this.data;
    },
  },

  computed: {
    limitTypes(): Array<DropdownList> {
      return [
        {
          label: getTranslate(
            'pages.campaignForm.tabs.options.blocks.limits.spend'
          ),
          value: ELimitType.SPEND,
        },
        {
          label: getTranslate(
            'pages.campaignForm.tabs.options.blocks.limits.impression'
          ),
          value: ELimitType.IMPRESSION,
        },
        {
          label: getTranslate(
            'pages.campaignForm.tabs.options.blocks.limits.clicks'
          ),
          value: ELimitType.CLICKS,
        },
      ];
    },
    goals(): Array<DropdownList> {
      return [
        {
          label: getTranslate(
            'pages.campaignForm.tabs.options.blocks.limits.total'
          ),
          value: ELimitGoal.TOTAL,
        },
        {
          label: getTranslate(
            'pages.campaignForm.tabs.options.blocks.limits.daily'
          ),
          value: ELimitGoal.DAILY,
        },
      ];
    },
    budgetHelpText(): string {
      switch (this.campaign.limit_type) {
        case ELimitType.SPEND:
          return '₽';
        case ELimitType.IMPRESSION:
          return getTranslate(
            'pages.campaignForm.tabs.options.blocks.limits.labelImpression'
          );
        case ELimitType.CLICKS:
          return getTranslate(
            'pages.campaignForm.tabs.options.blocks.limits.labelClicks'
          );
        default:
          return '';
      }
    },
  },

  methods: {
    change(name, value) {
      this.$emit('changeCampaign', name, value);
    },
    changeChecked(checked) {
      this.change('is_limit_budget', checked);
    },
  },

  data() {
    return {
      campaign: this.data,
    };
  },
});
